import { render, staticRenderFns } from "./resource-ebs.vue?vue&type=template&id=59fcf913"
import script from "./resource-ebs.vue?vue&type=script&lang=js"
export * from "./resource-ebs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports